export const usePermissions = (permission, admin) => {
  const isAdminUser = admin || permission?.healthEquityConditionList?.userRole === 'Super Admin'
  const exportPermissionValue = permission?.healthEquityConditionList?.chatbotExportPermissions?.[0]
  const copyPermissionValue = permission?.healthEquityConditionList?.chatbotCopyPermissions?.[0]
  const canExport = isAdminUser ? exportPermissionValue !== 0 : exportPermissionValue === 1
  const canCopy = isAdminUser ? copyPermissionValue !== 0 : copyPermissionValue === 1

  return {
    canExport,
    canCopy,
    isAdminUser
  }
}

/*
CHATBOT PERMISSIONS HOOK

KEY FUNCTIONS:
- usePermissions: Determines user permissions for chatbot features
- Evaluates export and copy permissions based on user role
- Handles admin vs regular user permission logic

FEATURES:
- Role-based permission evaluation
- Admin privilege detection
- Export permission management
- Copy functionality access control
- Super Admin role recognition
*/
